export const initialHomeVideosState = {
    videosByThumbnailByHomeIdBySmartModuleId: {},
    videoKeysByHomeIdBySmartModuleIdBySearchParams: {},
};
